import React from 'react';
import PropTypes from 'prop-types';
import LinearProgress from '@material-ui/core/LinearProgress';
import { withStyles } from '@material-ui/core/styles';
import styles from './BorderLinearProgress.styles';

const BorderLinearProgress = (props) => <LinearProgress {...props} />;

BorderLinearProgress.propTypes = {
  /** The value of the progress indicator for the determinate variant. Value between 0 and 100. */
  value: PropTypes.number,
  /** The variant to use. Use indeterminate or query when there is no progress value. */
  variant: PropTypes.oneOf(['determinate', 'indeterminate', 'query']),
};

BorderLinearProgress.defaultProps = {
  variant: 'indeterminate',
};

export default withStyles(styles)(BorderLinearProgress);
